<template>
  <div class="qcrb-basicInfo">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <el-form
            ref="basicForm"
            :model="basicForm"
            label-width="120px">
            <el-col :span="24">
              <div class="basic-title"><em>学生基础信息</em></div>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="姓名："
                class="rules-wrap">
                <el-input
                  class="jm-input220"
                  v-model="basicForm['custom_name']"/>
                <span
                  v-if="buttonMsg.custom_name"
                  class="rules-span">姓名必填</span>
              </el-form-item>
              <el-form-item
                label="性别："
                class="rules-wrap">
                <jm-dict-select
                  clearable
                  class="jm-input135"
                  name="gender"
                  v-model="basicForm['custom_sex']"
                  type="dataset"
                  dict-type="student"/>
                <span
                  v-if="buttonMsg.custom_sex"
                  class="rules-span">性别必填</span>
              </el-form-item>
              <el-form-item
                label="户籍地："
                class="rules-wrap">
                <jm-areaselect
                  v-model="domicile"
                  @change="setDomicile"/>
                <span
                  v-if="buttonMsg[0]"
                  class="rules-span1">省必填</span>
                <span
                  v-if="buttonMsg[1]"
                  class="rules-span2">市必填</span>
              </el-form-item>
              <el-form-item
                label="学生毕业时间："
                class="rules-wrap">
                <el-date-picker
                  class="jm-input220"
                  :editable="false"
                  clearable
                  type="month"
                  placeholder="选择日期"
                  v-model="basicForm['custom_over']"
                  format="yyyy-MM-dd"/>
                <span
                  v-if="buttonMsg.custom_over"
                  class="rules-span">毕业时间必填</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="入学时间："
                class="rules-wrap">
                <el-date-picker
                  :editable="false"
                  clearable
                  v-model="basicForm['custom_year']"
                  format="yyyy"
                  type="year"
                  placeholder="请选择"
                  class="jm-input135"
                  @change="() => this.basicForm.custom_month = ''"/>
                <el-date-picker
                  :editable="false"
                  clearable
                  :disabled="!basicForm.custom_year"
                  v-model="basicForm['custom_month']"
                  format="MM"
                  type="month"
                  placeholder="请选择"
                  popper-class="hidden-year"
                  class="jm-input135" />
                <span
                  v-if="buttonMsg.custom_year"
                  class="rules-span1">入学年份必填</span>
                <span
                  v-if="buttonMsg.custom_month"
                  class="rules-span2">入学月份必填</span>
              </el-form-item>
              <el-form-item
                label="最后所读学校："
                class="rules-wrap">
                <jm-dict-select
                  clearable
                  class="jm-input135"
                  v-model="basicForm['custom_school_type']"
                  type="dataset"
                  dict-type="student"
                  name="schoolType"/>
                <el-input
                  class="smallinput"
                  v-model="basicForm['custom_school']"/>
                <span
                  v-if="buttonMsg.custom_school_type"
                  class="rules-span1">最后所读学校必填</span>
                <span
                  v-if="buttonMsg.custom_school"
                  class="rules-span2">学校名称必填</span>
              </el-form-item>
              <el-form-item
                label="是否在日："
                class="rules-wrap">
                <jm-dict-select
                  clearable
                  name="handleYesNo"
                  type="dataset"
                  dict-type="qcrb"
                  v-model="basicForm['custom_injapan']"/>
                <span
                  v-if="buttonMsg.custom_injapan"
                  class="rules-span">是否在日必填</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="生日："
                class="rules-wrap">
                <el-date-picker
                  class="jm-input220"
                  :editable="false"
                  clearable
                  type="date"
                  placeholder="选择日期"
                  v-model="basicForm['custom_birthday']"
                  format="yyyy-MM-dd"/>
                <span
                  v-if="buttonMsg.custom_birthday"
                  class="rules-span">生日必填</span>
              </el-form-item>
              <el-form-item
                label="最后所读专业："
                class="rules-wrap">
                <el-input
                  class="jm-input220"
                  v-model="basicForm['custom_major']"/>
                <span
                  v-if="buttonMsg.custom_major"
                  class="rules-span">最后所读专业必填</span>
              </el-form-item>
              <el-form-item
                label="最高学历："
                class="rules-wrap">
                <jm-dict-select
                  clearable
                  class="jm-input220"
                  v-model="basicForm['custom_education']"
                  dict-type="education"/>
                <span
                  v-if="buttonMsg.custom_education"
                  class="rules-span">最高学历必填</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="basic-title"><em>均分及语言成绩</em></div>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否有日语成绩：" class="rules-wrap">
                <el-select
                  v-model="basicForm['has_jp_score']"
                  clearable
                  placeholder="请选择">
                  <el-option
                    :key="1"
                    label="是"
                    :value="1"/>
                  <el-option
                    :key="2"
                    label="否"
                    :value="2"/>
                </el-select>
                <span
                  v-if="buttonMsg.has_jp_score"
                  class="rules-span">是否有日语成绩必填</span>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="是否有英语成绩：" class="rules-wrap">
                <el-select
                  v-model="basicForm['has_en_score']"
                  clearable
                  placeholder="请选择">
                  <el-option
                    :key="1"
                    label="是"
                    :value="1"/>
                  <el-option
                    :key="2"
                    label="否"
                    :value="2"/>
                </el-select>
                <span
                  v-if="buttonMsg.has_en_score"
                  class="rules-span">是否有英语成绩必填</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="GPA：" class="rules-wrap">
                <el-input
                  class="jm-input220"
                  v-model="basicForm['custom_avg_score']"/>
                <span
                  v-if="buttonMsg.custom_avg_score"
                  class="rules-span">GPA必填</span>
              </el-form-item>
              <el-form-item label="BJT：">
                <jm-dict-select
                  clearable
                  class="jm-input90"
                  v-model="basicForm.scores['BJT']['ln_level']"
                  dict-type="examjp_d"
                  :filter="item => item.pid === 91"/>
                <el-input
                  type="number"
                  class="smallinput"
                  v-model="basicForm.scores['BJT']['ln_all']"/>
              </el-form-item>
              <el-form-item label="TOEIC：">
                <el-input
                  type="number"
                  class="smallinput"
                  v-model="basicForm.scores['TOEIC']['ln_all']"/>
              </el-form-item>
              <el-form-item label="语言成绩刷新类型1：">
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  :dict-type="['exam', 'examjp']"
                  :filter="refreshTypeFilter"
                  v-model="basicForm['lang_score1_type']"/>
              </el-form-item>
              <el-form-item label="语言成绩刷新类型2：">
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  :dict-type="['exam', 'examjp']"
                  :filter="refreshTypeFilter"
                  v-model="basicForm['lang_score2_type']"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="JLPT：">
                <jm-dict-select
                  clearable
                  class="jm-input90"
                  v-model="basicForm.scores['JLPT']['ln_level']"
                  dict-type="examjp_d"
                  :filter="item => item.pid === 89"/>
                <el-input
                  type="number"
                  class="smallinput"
                  v-model="basicForm.scores['JLPT']['ln_all']"/>
              </el-form-item>
              <el-form-item label="NAT：">
                <jm-dict-select
                  clearable
                  class="jm-input90"
                  v-model="basicForm.scores['NAT']['ln_level']"
                  dict-type="examjp_d"
                  :filter="item => item.pid === 92"/>
                <el-input
                  type="number"
                  class="smallinput"
                  v-model="basicForm.scores['NAT']['ln_all']"/>
              </el-form-item>
              <el-form-item label="IELTS：">
                <el-input
                  class="jm-input220"
                  v-model="basicForm.scores['IELTS']['ln_all']"/>
              </el-form-item>
              <el-form-item label="语言成绩刷新时间1：">
                <el-date-picker
                  class="jm-input220"
                  :editable="false"
                  clearable
                  v-model="basicForm['lang_score1_date']"
                  type="date"
                  placeholder="选择日期"/>
              </el-form-item>
              <el-form-item label="语言成绩刷新时间2：">
                <el-date-picker
                  class="jm-input220"
                  :editable="false"
                  clearable
                  v-model="basicForm['lang_score2_date']"
                  type="date"
                  placeholder="选择日期"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="J-TEST：">
                <jm-dict-select
                  clearable
                  class="jm-input90"
                  v-model="basicForm.scores['J-TEST']['ln_level']"
                  dict-type="examjp_d"
                  :filter="item => item.pid === 90"/>
                <el-input
                  type="number"
                  class="smallinput"
                  v-model="basicForm.scores['J-TEST']['ln_all']"/>
              </el-form-item>
              <el-form-item label="TOEFL：">
                <el-input
                  class="jm-input220"
                  type="number"
                  v-model="basicForm.scores['TOEFL']['ln_all']"/>
              </el-form-item>
              <el-form-item label="CET：">
                <jm-dict-select
                  clearable
                  class="jm-input90"
                  v-model="basicForm.scores['CET']['ln_level']"
                  dict-type="exam_cet"/>
                <el-input
                  type="number"
                  v-model="basicForm.scores['CET']['ln_all']"
                  class="smallinput"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="basic-title"><em>办理信息</em></div>
            </el-col>
            <el-row class="clearfix jm-cb">
              <el-col :span="6">
                <el-form-item
                  label="申请项目："
                  class="rules-wrap">
                  <jm-dict-select
                    clearable
                    class="jm-input135"
                    v-model="basicForm.baseinfo.course_id"
                    dict-type="course"
                    :filter="item => item.pid === 485"/>
                  <span
                    v-if="buttonMsg.course_id"
                    class="rules-span">申请项目必填</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="办理状态："
                  class="rules-wrap">
                  <jm-dict-select
                    clearable
                    name="handleStateAdd"
                    type="dataset"
                    dict-type="qcrb"
                    v-model="basicForm.baseinfo.status"/>
                  <span
                    v-if="buttonMsg.status"
                    class="rules-span">办理状态必填</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-form-item label="APP 订单：" v-if="basicForm.payment.entry.length">
                <el-table :data="basicForm.payment.entry" style="width: 100%" size="mini">
                  <el-table-column prop="srv_name" label="产品名称"/>
                  <el-table-column prop="srv_group" label="产品类型"/>
                  <el-table-column prop="srv_amount" label="合同金额"/>
                  <el-table-column prop="total_amount" label="服务费"/>
                  <el-table-column prop="bargain_amount" label="服务费定金"/>
                  <el-table-column prop="first_amount" label="服务费首款"/>
                  <el-table-column prop="last_amount" label="服务费尾款"/>
                </el-table>
              </el-form-item>

              <el-form-item label="前程订单：" v-if="basicForm.payment.fmis.length">
                <el-table :data="basicForm.payment.fmis" style="width: 100%" size="mini">
                  <el-table-column prop="order_title" label="订单名称"/>
                  <el-table-column prop="need_fee" label="应付总额"/>
                  <el-table-column prop="service_fee" label="服务金额"/>
                  <el-table-column prop="deposit_fee" label="押金"/>
                  <el-table-column prop="paid_fee" label="已付金额"/>
                  <el-table-column prop="last_payment_date" label="最后付款日" />
                </el-table>
              </el-form-item>

              <!-- 未发先订单信息 -->
              <el-form-item label="订单数据：" v-if="buttonMsg.total_amount">
                <el-alert type="error" title="暂无有效的订单/报账数据，请联系老师添加" :closable="false"></el-alert>
              </el-form-item>
            </el-row>

            <el-col :span="24">
              <div class="basic-title"><em>签约确认表</em></div>
            </el-col>
            <el-col :span="24">
              <el-form-item class="rules-wrap">
                <div class="basic-padding" >
                  <quill-editor
                    v-model="basicForm.baseinfo.confirm_form"
                    :options="editorOption"/>
                  <span
                    class="rules-span3"
                    v-if="buttonMsg.confirm_form">签约确认表必填</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="basic-title"><em>电子版合同</em></div>
            </el-col>
            <el-col :span="8">
              <div
                class="basic-padding2"
                :class="this.uploadHidden? '' : 'basicInfo'">
                <el-button
                  v-if="!this.uploadHidden"
                  type="primary"
                  size="small"
                  @click="uploadCheck()">上传电子版合同</el-button>
                <template v-if="(typeof basicForm.crm_id) !== 'undefined'">
                  <jm-upload-file
                    url="/newfib.php/index/apply_file/upload"
                    :upload-data="{crm_id: basicForm.crm_id, offer_id: basicForm.baseinfo.offer_id}"
                    :show-file-list="true"
                    :upload-additional="{upload_position: '电子版合同', upload_type_str: '电子版合同', offer_school_id: 0}"
                    :is-function="onSubmit"
                  >
                    <template slot="uploadFile">
                      <el-button
                        v-show="this.uploadHidden"
                        type="primary"
                        size="small">上传电子版合同</el-button>
                        <!-- <div class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                    </template>
                  </jm-upload-file>
                </template>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="basic-title"><em>二次销售</em></div>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否在我公司办理签证：" label-width="200px">
                <jm-dict-select
                  clearable
                  type="dataset"
                  dict-type="qcrb"
                  v-model="basicForm.baseinfo.is_resale_visa"
                  name="handleYesNo"/>
              </el-form-item>
              <el-form-item label="手机是否在我公司办理：" label-width="200px">
                <jm-dict-select
                  clearable
                  type="dataset"
                  dict-type="qcrb"
                  v-model="basicForm.baseinfo.is_resale_phone"
                  name="handleYesNo"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签证是否下达：" label-width="200px">
                <jm-dict-select
                  clearable
                  type="dataset"
                  dict-type="qcrb"
                  v-model="basicForm.baseinfo.visa_status"
                  name="handleYesNo"/>
              </el-form-item>
              <el-form-item label="房屋是否在我公司办理：" label-width="200px">
                <jm-dict-select
                  clearable
                  type="dataset"
                  dict-type="qcrb"
                  v-model="basicForm.baseinfo.is_resale_house"
                  name="handleYesNo"/>
              </el-form-item>
            </el-col>
          </el-form>
          <el-col :span="24">
            <div class="basic-padding2">
              <el-button
                type="primary"
                :loading="saving"
                @click="onSubmit">提交保存</el-button>
            </div>
          </el-col>
        </div>
        <div
          class="draft-area"
          v-show="draftHidden">
          <el-button
            type="primary"
            @click="draftLoad">加载草稿</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import { jmAreaselect, jmDictSelect, jmUploadFile } from '@/components/tool';
import * as UserApi from '@/api/user.js';
import {
  formatCustomMonth,
  formatCustomYear,
  getCustomYear,
  getCustomMonth
} from '@/utils/utils.js';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  data() {
    let dList = [
      ['domicile', '0'],
      ['domicile', '1'],
      ['basicForm', 'custom_name'],
      ['basicForm', 'custom_sex'],
      ['basicForm', 'custom_over'],
      ['basicForm', 'custom_year'],
      ['basicForm', 'custom_month'],
      ['basicForm', 'custom_school_type'],
      ['basicForm', 'custom_school'],
      ['basicForm', 'custom_injapan'],
      ['basicForm', 'custom_birthday'],
      ['basicForm', 'custom_major'],
      ['basicForm', 'custom_education'],
      ['basicForm', 'baseinfo', 'course_id'],
      ['basicForm', 'baseinfo', 'status'],
      // ['basicForm', 'payment', 'total_amount'],
      ['basicForm', 'baseinfo', 'confirm_form'],
      ['basicForm', 'has_jp_score'],
      ['basicForm', 'has_en_score'],
      ['basicForm', 'custom_avg_score']
    ];
    let buttonMsg = {
      score_jp: false,
      score_en: false
    };
    // eslint-disable-next-line
    for (let i in dList) {
      let cloneList = this.clone(dList[i]);
      buttonMsg[cloneList.pop()] = false;
    }
    return {
      saving: false,
      domicile: '', // 户籍
      formDraft: {},
      draftHidden: false, // 草稿开关
      isCheck: false, // 是否开启验证
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            ['bold', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            ['clean']
          ]
        }
      },
      buttonMsg: buttonMsg,
      deList: dList,
      basicForm: {
        has_jp_score: null,
        has_en_score: null,
        custom_avg_score: '',
        custom_name: null,
        custom_sex: null,
        custom_over: null,
        custom_year: null,
        custom_month: null,
        custom_school_type: null,
        custom_school: null,
        custom_injapan: null,
        custom_major: null,
        custom_education: null,
        custom_birthday: '',
        lang_score1_date: '',
        lang_score2_date: '',
        baseinfo: {
          course_id: null,
          status: null
        },
        scores: {
          BJT: { ln_type: 91 },
          JLPT: { ln_type: 89 },
          'J-TEST': { ln_type: 90 },
          NAT: { ln_type: 92 },
          TOEFL: { ln_type: 23 },
          CET: { ln_type: 671 },
          TOEIC: { ln_type: 129 },
          IELTS: { ln_type: 22 }
        }, // 成绩
        payment: {
          entry: [], // 旧版订单
          fmis: [] // 新版订单
        }
      },
      temporaryId: {} // 临时提交保存id
    };
  },
  computed: {
    uploadHidden() {
      return this.getValidation();
    }
  },
  methods: {
    isEmpty(value) {
      if (Array.isArray(value)) {
        return !(value[0] && value[1]);
      }
      return (!value && value === '') || value === null;
    },
    /** 更新成绩数据，防止多次插入数据库 */
    fillScores(scores) {
      Object.entries(this.basicForm.scores).forEach(([k, v]) => {
        scores.forEach((score) => {
          if (v.ln_type === score.ln_type) {
            this.basicForm.scores[k] = Object.assign(v, score);
          }
        });
      });
    },
    /**
     * Description: 验证方法
     * return boolean true为有问题，false为没有问题
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getValidation() {
      let dList = this.deList;
      let result = true;
      // eslint-disable-next-line
      for (let i in dList) {
        let a = '';
        let cloneList = this.clone(dList[i]);
        if (cloneList.length === 2) {
          a = this[cloneList[0]][cloneList[1]];
        } else if (cloneList.length === 3) {
          a = this[cloneList[0]][cloneList[1]][cloneList[2]];
        }
        if (typeof a === 'undefined' || a === '' || a === null) {
          this.buttonMsg[cloneList.pop()] = true;
          result = false;
        } else {
          // console.log(a, cloneList);
          this.buttonMsg[cloneList.pop()] = false;
        }
      }

      // 是否有日语成绩
      if (this.basicForm.has_jp_score === 1 || this.basicForm.has_jp_score === '1') {
        let resultJp = false; // 默认出错
        let score = ['J-TEST', 'BJT', 'JLPT', 'NAT'];
        score.forEach((k) => {
          if (this.basicForm.scores[k].ln_level && this.basicForm.scores[k].ln_all) {
            resultJp = true;
          }
        });

        this.buttonMsg.score_jp = !resultJp;
        if (resultJp === false) {
          result = false;
        }
      }

      // 是否有英语成绩
      if (this.basicForm.has_en_score === 1 || this.basicForm.has_en_score === '1') {
        let resultEn = false; // 默认出错

        let score = ['CET'];
        score.forEach((k) => {
          if (this.basicForm.scores[k].ln_level && this.basicForm.scores[k].ln_all) {
            resultEn = true;
          }
        });

        score = ['TOEFL', 'TOEIC', 'IELTS'];
        score.forEach((k) => {
          if (this.basicForm.scores[k].ln_all) {
            resultEn = true;
          }
        });

        this.buttonMsg.score_en = !resultEn;
        if (resultEn === false) {
          result = false;
        }
      }

      // 电子版合同单独验证，有产品数据展示方可通过
      if (this.basicForm.payment.entry.length || this.basicForm.payment.fmis.length) {
        this.buttonMsg.total_amount = false;
      } else {
        // 验证失败
        this.buttonMsg.total_amount = true;
        result = false;
      }
      return result;
    },
    /**
     * 重新处理提交数据
     *
     * yanlichen <yanlichen@tuozhongedu.com>
     */
    getbasicData() {
      return {
        ...this.basicForm,
        ...this.temporaryId,
        custom_year: formatCustomYear(this.basicForm.custom_year),
        custom_month: formatCustomMonth(this.basicForm.custom_month)
      };
    },
    /**
     * 保存提交
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    onSubmit() {
      this.saving = true;
      this.$http
        ._post({
          url: '/index/qc_process/saveProcess',
          data: this.getbasicData()
        })
        .then(({ data }) => {
          this.fillScores(data);
          this.$message.success('保存成功');
          this.saving = false;
          window.location.reload();
        });
    },
    /**
     * 自动保存
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    autoSave() {
      setInterval(() => this.onDraftSubmit(), 30000);
    },
    /**
     * 获取草稿
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getDraft() {
      this.$http
        ._get({
          url: `/index/qc_process/getDraft?type=baseinfo&crmid=${this.$route
            .params.crmid}`
        })
        .then(({ data }) => {
          this.formDraft = data;
          if (this.formDraft !== '') {
            this.draftHidden = true;
          }
        });
    },
    /**
     * 自动草稿提交
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    onDraftSubmit() {
      this.$http
        ._post({
          url: '/index/qc_process/saveDraft?type=baseinfo',
          data: this.getbasicData()
        })
        .then(() => {
          this.$message.success('已自动保存草稿');
        });
    },
    /**
     * 加载草稿
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    draftLoad() {
      this.basicForm = this.formDraft;
      this.draftHidden = false;
      this.$message.success('已加载草稿');
    },
    /**
     * 学生基础信息
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getStudent() {
      return new Promise((resolve) => {
        UserApi.getBaseInfo(this.$route.params.crmid).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
     * 成绩信息
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    getScores() {
      return new Promise((resolve) => {
        UserApi.getScores(this.$route.params.crmid).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
     * 办理信息
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getPayment() {
      return new Promise((resolve) => {
        this.$http
          ._get({
            url: `/index/qc_process/getProcess/crmid/${this.$route.params
              .crmid}`
          })
          .then(({ data }) => {
            resolve(data);
          });
      });
    },
    /**
     * 户籍组件绑定
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    basicDomicile() {
      this.domicile = [
        this.basicForm.custom_place_area,
        this.basicForm.custom_place_city
      ];
    },
    /**
     * 户籍组件初始值
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    setDomicile(value) {
      this.basicForm.custom_place_area = value[0];
      this.basicForm.custom_place_city = value[1];
    },
    /**
     * 语言成绩刷新类型filter
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Object} item
     * @return {Boolean}
     */
    refreshTypeFilter(item) {
      return (
        [
          'JLPT',
          'J-TEST',
          'BJT',
          'NAT',
          'TOEFL',
          'TOEIC',
          'IELTS',
          'CET'
        ].indexOf(item.value) > -1
      );
    },
    /**
     * 电子版合同上传验证
     */
    uploadCheck() {
      if (!this.getValidation()) {
        let list = {
          0: '省',
          1: '市',
          confirm_form: '签约确认表',
          course_id: '申请项目',
          custom_birthday: '用户生日',
          custom_education: '最高学历',
          custom_injapan: '在日信息',
          custom_major: '专业',
          custom_month: '入学月',
          custom_name: '用户名',
          custom_over: '毕业时间',
          custom_school: '最后就读学校',
          custom_school_type: '学校类型',
          custom_sex: '用户性别',
          custom_year: '入学年',
          status: '办理状态',
          has_jp_score: '是否有日语成绩',
          has_en_score: '是否有英语成绩',
          custom_avg_score: 'GP',
          score_jp: '日语成绩',
          score_en: '英语成绩'
          // total_amount: '服务费'
        };
        let keys = Object.keys(this.buttonMsg);
        let keyList = [];
        keys.map((d) => {
          if (this.buttonMsg[d]) {
            keyList.push(list[d]);
          }
          return d;
        });
        // keyList = ['a', 'b'];
        let msgStr = `${keyList.toString()}`;

        if (msgStr !== '') {
          msgStr = `${msgStr}数据不全! `;
        }

        if (this.buttonMsg.total_amount) {
          msgStr += '所购产品尚未确认付款';
        }
        this.$message.error(msgStr);
      }
    },
    clone(list) {
      return Object.values(list);
      /* let a = [];
      for (let i in list) {
        a.push(list[i]);
      }
      return a; */
    }
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      // this.rulesValidation();
      // 成绩信息
      this.getScores().then((data) => {
        Object.assign(this.basicForm.scores, data);
      });
      // 学生基础信息
      this.getStudent().then((data) => {
        Object.assign(this.basicForm, data);
        this.basicDomicile();
        this.basicForm.custom_year = getCustomYear(data.custom_year);
        this.basicForm.custom_month = getCustomMonth(data.custom_month);
      });
      // 办理信息
      this.getPayment().then((data) => {
        Object.assign(this.basicForm, data);
        if (data.baseinfo.course_id === 0) {
          this.basicForm.baseinfo.course_id = '';
        }
        if (data.baseinfo.status === 0) {
          this.basicForm.baseinfo.status = '';
        }
        this.temporaryId = {
          crm_id: data.crm_id,
          id: data.id
        };
      });
      // 获取草稿
      this.getDraft();
      // 自动保存
      this.autoSave();
    });
  },
  components: {
    'jm-crumbs': crumbs,
    jmAreaselect,
    jmUploadFile,
    jmDictSelect,
    quillEditor
  }
};
</script>
<style scoped>
.qcrb-basicInfo .smallselect,
.qcrb-basicInfo .smallinput {
  width: 49%;
}
.basic-padding {
  padding: 0 10px;
}
.basic-padding2 {
  padding: 20px 10px;
  text-align: left;
}
.quill-editor {
  min-height: 242px;
  max-height: 400px;
  overflow-y: auto;
}
.rules-wrap {
  position: relative;
}
.rules-wrap .rules-span {
  position: absolute;
  color: #ff0000;
  left: 2px;
  top: 30px;
}
.rules-wrap .rules-span1 {
  position: absolute;
  color: #ff0000;
  left: 2px;
  top: 28px;
}
.rules-wrap .rules-span2 {
  position: absolute;
  color: #ff0000;
  left: 142px;
  top: 28px;
}
.rules-wrap .rules-span3 {
  position: absolute;
  color: #ff0000;
  left: 12px;
  bottom: -30px;
}
</style>
<style>
.basicInfo .el-upload--text{
  float: left;
}
.hidden-year div.el-date-picker__header {
  display: none !important;
}
.draft-area {
  position: fixed;
  bottom: 30px;
  left: 10px;
}
.quill-editor .ql-container {
  height: 200px !important;
}
</style>
